import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { updateFirebaseUserIdApi } from './updateFirebaseUserId.api'
import updateFirebaseUserIdInitialState from './updateFirebaseUserId.initialState'
import { UpdateFirebaseUserIdErrorResponse, UpdateFirebaseUserIdRequestPayload } from './updateFirebaseUserId.types'

export const updateFirebaseUserId = createAsyncThunk(
  urls.profile.updateFirebaseUserId,
  async (payload: UpdateFirebaseUserIdRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await updateFirebaseUserIdApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse, undefined, true)

      return rejectWithValue(error)
    }
  }
)

const updateFirebaseUserIdSlice = createSlice({
  name: urls.profile.updateFirebaseUserId,
  initialState: updateFirebaseUserIdInitialState,
  reducers: {
    resetUpdateFirebaseUserId: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateFirebaseUserId.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(updateFirebaseUserId.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(updateFirebaseUserId.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as UpdateFirebaseUserIdErrorResponse
        state.success = null
      })
  }
})

export const { actions: updateFirebaseUserIdActions, reducer: updateFirebaseUserIdReducer } = updateFirebaseUserIdSlice
export const { resetUpdateFirebaseUserId } = updateFirebaseUserIdActions
export default updateFirebaseUserIdSlice.reducer
